<dff-side [observable]="installationer$">
  @if (installationer$ | async; as installationer) {
    @if (installationer.length !== 0) {
      <dff-side-titel>Vælg installation</dff-side-titel>
      <installation-liste [installationer]="installationer" (select)="onVaelgInstallation($event)"></installation-liste>
    }
    @if (installationer.length === 0) {
      <empty-page-badge svgIcon="page-error-icon" overskrift="Ugyldig installation">
        <p>Den forespurgte forbruger og installation findes ikke.</p>
        <button mat-flat-button color="primary" (click)="onSeAlleInstallationer()">Se alle installationer</button>
      </empty-page-badge>
    }
  } @else {
    <mat-spinner class="mat-spinner"></mat-spinner>
  }
</dff-side>
